import { Ptag } from "components/core";
import React from "react";
import { colors } from "theme";

function ClaimDetail({ title, value }) {
  return (
    <div>
      <Ptag fontWeight="700" fontSize="16px" color={colors.primaryColor}>
        {title}
      </Ptag>
      <Ptag fontWeight="500" marginTop="6px" fontSize="14px" color="#4a4a4a">
        {value}
      </Ptag>
    </div>
  );
}

export default ClaimDetail;
